<h1 class="text-center wow bounceInDown font-audiowide" data-wow-duration="2s"><span [style.font-weight]="'bold'"
    [style.font-size]="'140%'">THREATSCORE</span> <em [style.color]="'#009ed8'"> by <b>Cyberprotect</b></em></h1>

<h2 class="text-center text-muted mb-5 wow bounceInDown font-audiowide" data-wow-duration="2s">
  Based on <img height="75" src="assets/img/nicki-logo.png" alt="NICKI - New Intelligence for Cyber-threat Knowledge Inter-connectivity">

</h2>
<hr />
